import { createSelector } from '@reduxjs/toolkit';
import { functionsNotDeleted, singleFunctionTemplateIds } from 'src/store/selectors';

export const hseManagerUuid = createSelector(
  functionsNotDeleted,
  (functions) => functions.find((c) => c.mainTemplateId === singleFunctionTemplateIds.hseManager)?.uuid,
);
